"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _messagePage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/message-page.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _messagePage.default);
/**
 * Message page displays a message to the user when an app or list is empty or
 * if an error has occurred. The text and icon on the message page changes
 * depending on the use case, however, the layout stays the same. It is
 * responsive and adjusts to fit the available screen space.
 *
 * ##### The message page can be used in the following situations:
 *
 * * Filter with no results
 * * Search with no results
 * * Empty app
 * * Too many items
 * * Item saved as a tile that is no longer available
 * * Error
 *
 * @returns {Node} MessageBox component
 */

function MessagePage(_ref) {
  var actions = _ref.actions,
      cssNamespace = _ref.cssNamespace,
      className = _ref.className,
      image = _ref.image,
      glyph = _ref.glyph,
      title = _ref.title,
      more = _ref.more,
      subtitle = _ref.subtitle,
      props = (0, _objectWithoutProperties2.default)(_ref, ["actions", "cssNamespace", "className", "image", "glyph", "title", "more", "subtitle"]);
  return /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({
    className: classnames("".concat(cssNamespace, "-message-page"), className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__container"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__icon-container"))
  }, !image && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaLabel: glyph,
    className: classnames("".concat(cssNamespace, "-message-page__icon")),
    glyph: glyph
  }), image), /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    className: classnames("".concat(cssNamespace, "-message-page__content")),
    role: "status"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__title"))
  }, title), subtitle && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__subtitle"))
  }, subtitle), actions && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__actions"))
  }, actions), more && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-message-page__more"))
  }, more))));
}

process.env.NODE_ENV !== "production" ? MessagePage.propTypes = {
  /** Glyph to use for the icon */
  glyph: _propTypes.default.string.isRequired,

  /** Localized text for the title */
  title: _propTypes.default.string.isRequired,

  /** Content to use in the actions section */
  actions: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Image (or any other content) to use in place of the original icon */
  image: _propTypes.default.node,

  /** Content to use in the "more" section */
  more: _propTypes.default.node,

  /** Content to use for the subtitle */
  subtitle: _propTypes.default.node
} : void 0;
MessagePage.defaultProps = {
  glyph: 'product'
};

var _default = (0, _withStyles.default)(MessagePage);

exports.default = _default;